import React from 'react';
import { IndicatorProps, components } from 'react-select';
import { FilterOptionType } from 'Book/shared';
import * as S from '../../styles';

export default (
  props: IndicatorProps<FilterOptionType, true> & { isOpen: boolean },
) => (
  <components.DropdownIndicator {...props}>
    {props.isOpen ? <S.Up /> : <S.Down />}
  </components.DropdownIndicator>
);
